import { render } from "./user-create.vue?vue&type=template&id=16336b3a&scoped=true"
import script from "./user-create.vue?vue&type=script&lang=js"
export * from "./user-create.vue?vue&type=script&lang=js"

import "./user-create.vue?vue&type=style&index=0&id=16336b3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16336b3a"]])

export default __exports__